export default __webpack_public_path__ + "static/media/interiorBG.6ce92a46.png";